import { PropsWithClassname } from "@/types";
import { cn, Spinner, SpinnerProps } from "@heroui/react";

export const Pending = ({ className, ...props }: PropsWithClassname & SpinnerProps) =>
(<div className={cn("w-full flex justify-center mt-10", className)}>
  <Spinner {...props} />
</div>)